module.exports = __webpack_public_path__ + "static/media/image1.83946a45.JPG";